import {eventActionType} from '../../constants';

const initialState = {
    events: [],
    totalRecord: 0,
    isLoading: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case eventActionType.FETCH_EVENTS:
            // Extract events array from paginated API response
            const eventsData = action.payload?.data || action.payload || [];
            const total = action.payload?.total || eventsData.length;
            return {
                ...state,
                events: Array.isArray(eventsData) ? eventsData : [],
                totalRecord: total
            };
        case eventActionType.FETCH_EVENT:
            return {
                ...state,
                events: [action.payload]
            };
        case eventActionType.ADD_EVENT:
            return {
                ...state,
                events: [...state.events, action.payload]
            };
        case eventActionType.EDIT_EVENT:
        case eventActionType.TOGGLE_EVENT_ACTIVE:
        case eventActionType.TOGGLE_EVENT_FEATURED:
            return {
                ...state,
                events: state.events.map(item => item.id === +action.payload.id ? action.payload : item)
            };
        case eventActionType.DELETE_EVENT:
            return {
                ...state,
                events: state.events.filter(item => item.id !== action.payload)
            };
        default:
            return state;
    }
};
